import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthFormForgotPassword } from "@/components/features/auth/forgot-password";

export const AuthForgotPasswordPage = () => {
	return (
		<PageMeta title="" url={PATHS.AUTH.FORGOT_PASSWORD}>
			<AuthFormForgotPassword />
		</PageMeta>
	);
};
